module.exports = __webpack_public_path__ + "img/worldCupBannerMb.1aff0309.png";